import React from "react";
import { Link } from "react-router-dom";

/**
 * Wrapper for react router's link. Able to check host of property "to". If host is matched with window.host
 * or host is blank, will be rendered <Link> for react router. Else will be rendered simple html tag "a"
 * @name SmartLink
 * @param {object} props React component properties
 * @param {string} [props.to] Url for href
 * @param {string} [props.className] CSS-class name
 * @param {string} [props.target] Standard target attribute for links ("_blank", "_current" etc)
 * @param {func} [props.onClick] On click handler
 * @param {Object} [props.style] Inline styles
 * @example
 * return (
 *    <SmartLink className = { "link" }
 *               to = { "/path/to/page" }
 *               onClick = { (event) => {
 *                 // Some actions
 *               } } >
 *      { "CLICK ME!" }
 *    </SmartLink>
 * )
*/
class SmartLink extends React.Component {
  render() {
    const { to } = this.props;
    // * check if given href is absolute or relative
    const isRelative = RegExp(/^\/.*/, "g").test(to);
    if (isRelative) return this.link();
    const { host } = location;

    const linkRegExp = RegExp(`^http(?:s)?:\/\/(?:www.)?(?:${host})(.*)$`, "g");

    const result = linkRegExp.exec(to);
    if (result) {
      // * [1] - first group - relative path
      const internalLink = result[1] || "/";
      return this.link(internalLink);
    }

    return this.aLink();
  }

  aLink() {
    const { className, onClick, children, to, target, style, innerRef } = this.props;
    return <a href = { to }
              ref = { innerRef }
              onClick = { onClick }
              className = { className }
              target = { target }
              style = { style } >
      { children }
    </a>
  }

  link(internalLink) {
    const { className, target, onClick, children, to, style, innerRef } = this.props;
    return <Link to = { internalLink || to }
                 ref = { innerRef }
                 onClick = { onClick }
                 className = { className }
                 target = { target }
                 style = { style } >
      { children }
    </Link>
  }
}

SmartLink.defaultProps = {
}

export default React.forwardRef((props, ref) => <SmartLink 
  innerRef={ref} {...props}
/>);